import { AxiosResponse } from 'axios'

import getCookie from '../utils/getCookies'
import { apiformflow } from './api'

export const getFluxoFlowBySlug = (slug: string): Promise<AxiosResponse> => {
  const tokenSSO: string | null = getCookie('gov_access_token_sso')

  return apiformflow.get(`flow/fluxo/?slug=${slug}`, {
    headers: tokenSSO ? { Authorization: `Bearer ${tokenSSO}` } : {},
  })
}
